import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import CommandPalette from "./CommandPalette";
import {
  IconDashboard, IconInbox, IconLayers, IconCheckSquare, IconCalendar,
} from "../icons";

/* ── Mobile bottom nav — 5 prioritary entries ── */
const MOBILE_NAV = [
  { id: "dashboard",  label: "Accueil",    Icon: IconDashboard },
  { id: "demandes",   label: "Demandes",   Icon: IconInbox },
  { id: "contenus",   label: "Contenus",   Icon: IconLayers },
  { id: "projets",    label: "Tâches",     Icon: IconCheckSquare },
  { id: "calendrier", label: "Calendrier", Icon: IconCalendar },
];

export default function AppShell({ currentPage, onNavigate, children, badges = {}, currentUser, appId }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem("ep-sidebar-collapsed") === "1"; } catch { return false; }
  });

  function toggleCollapsed() {
    setCollapsed((v) => {
      const next = !v;
      try { localStorage.setItem("ep-sidebar-collapsed", next ? "1" : "0"); } catch {}
      return next;
    });
  }

  // Raccourci clavier global ⌘K / Ctrl+K → recherche.
  useEffect(() => {
    function onKey(e) {
      if ((e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div className={`v2-shell${collapsed ? " v2-shell--collapsed" : ""}`}>
      <Sidebar
        currentPage={currentPage}
        onNavigate={onNavigate}
        badges={badges}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        currentUser={currentUser}
        collapsed={collapsed}
      />

      <div className="v2-main">
        <Topbar
          currentPage={currentPage}
          onMenuOpen={() => setSidebarOpen(true)}
          onToggleCollapse={toggleCollapsed}
          collapsed={collapsed}
          onOpenSearch={() => setPaletteOpen(true)}
          notifCount={badges.demandes || 0}
          onNavigate={onNavigate}
          currentUser={currentUser}
        />
        <main className="v2-content" id="v2-main-content" role="main">
          {children}
        </main>
      </div>

      <CommandPalette
        open={paletteOpen}
        onClose={() => setPaletteOpen(false)}
        onNavigate={onNavigate}
        currentUser={currentUser}
        appId={appId}
      />

      {/* Mobile bottom navigation */}
      <nav className="v2-mobile-nav" aria-label="Navigation mobile">
        {MOBILE_NAV.map((item) => {
          const count = badges[item.id] || 0;
          return (
            <button
              key={item.id}
              className={`v2-mobile-nav__item${currentPage === item.id ? " active" : ""}`}
              onClick={() => onNavigate(item.id)}
              aria-label={item.label}
              aria-current={currentPage === item.id ? "page" : undefined}
            >
              <item.Icon size={21} />
              <span>{item.label}</span>
              {count > 0 && (
                <span className="v2-mobile-nav__badge">{count}</span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
